import React from 'react'

const DeviceOfflineBanner = ({
  downStamp,
  noConnectionKey,
  noConnectionSinceKey,
  hintKey,
  onRetry,
  t,
}) => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl bg-critical/10 px-5 py-3">
    <span className="material-icons text-critical">link_off</span>
    <div className="min-w-0 flex-1">
      <p className="text-sm text-white">
        {downStamp ? t(noConnectionSinceKey, { time: downStamp }) : t(noConnectionKey)}
      </p>
      <p className="text-xs text-muted-400">{t(hintKey)}</p>
    </div>
    <button
      type="button"
      onClick={onRetry}
      className="rounded-xl bg-white/[0.06] px-3 py-1.5 text-xs text-muted-200 transition hover:bg-white/[0.1] hover:text-white"
    >
      {t('device.checkAgain')}
    </button>
  </div>
)

export default DeviceOfflineBanner
